/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Badge_IsoInputs */



/**
* | output |
* | --- |
* | "ISO 9001 and ISO 45001" |
*
* @param {Home_Badge_IsoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_badge_iso = /** @type {((inputs?: Home_Badge_IsoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Badge_IsoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("ISO 9001 和 ISO 45001")
	return /** @type {LocalizedString} */ ("ISO 9001 and ISO 45001")
});